export const getOrdersName = orders => {
  const ordersName = orders?.map(transaction => transaction?.order?.name)

  const stringOrderNames = ordersName?.join(', ')

  return stringOrderNames
}
